import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import MaintenanceTable from '../../../../components/Tables/Warren/GeneralMaintenance';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SIMaintenancePrevent = () => {
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Preventive Maintenance</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Preventive Maintenance Tasks" className="mb-3 maintenance-element">
								<Tab eventKey="Preventive Maintenance Tasks" title="Preventive Maintenance Tasks">
									<h2>PREVENTIVE MAINTENANCE TASKS</h2>
									<p>The tables are intended as a guideline and should not replace periodic maintenance schedules derived in the plant.</p>
									<MaintenanceTable tablesorter={true} />
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenancePrevent;
